<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.exportacao"
        ref="DataTable"
        sort-by="unidade"
    >
        <template v-slot:cell(actions)="row">
            <rkm-button
                :disabled="!!row.item.encaminhado"
                @click="handleEncaminhar(row.item)"
                authorize="update-raas-exportacao"
                color="primary"
                small
                title="Encaminhar"
            >
                <rkm-icon icon="share" />
            </rkm-button>

            <rkm-button
                @click="handleDownload(row.item)"
                color="primary"
                small
                title="Download"
            >
                <rkm-icon icon="download" />
            </rkm-button>

            <rkm-button
                :disabled="!!row.item.encaminhado"
                @click="handleDestroy(row.item)"
                authorize="destroy-raas-exportacao"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import { error, repository, stringCase } from '@/mixins'

export default {
    created() {
        this.repositories.exportacao = this.getConectaSusRepository('raas.exportacao')
    },
    data: () => ({
        fields: [
            { key: 'dataHoraExportacao', label: 'Data / Hora da exportação' },
            { name: 'unidade.nomeFantasia', key: 'unidade', label: 'Unidade', searchable: true, sortable: true },
            { name: 'competencia.valor', key: 'competencia', label: 'Competência', searchable: true, sortable: true },
            { key: 'financiamentos', label: 'Financiamentos', class: 'col-6' },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' },
        ],
        repositories: {},
    }),
    methods: {
        refresh() {

            this.$refs.DataTable.refresh()
        },
        handleEncaminhar(item) {
            const request = { encaminhado: true }

            this.repositories.exportacao.update(item.id, this.camelObjectKeysToSnakeRecursive(request))
                .then(() => {
                    this.$refs.DataTable.refresh()
                    this.showSaveNotification()
                })
                .catch(this.handleError)
        },
        handleDownload(item) {
            this.repositories.exportacao.download(item.id)
                .then(response => {
                    const file = response.headers['content-disposition'].split('filename=')[1]
                    const blob = new Blob([response.data])
                    const link = document.createElement('a')

                    link.href = URL.createObjectURL(blob)
                    link.download = file
                    link.click()
                })
                .catch(this.handleError)
        },
        handleDestroy(item) {
            const destroy = () => this.repositories.exportacao.destroy(item.id)
                .then(() => {
                    this.$refs.DataTable.refresh()
                })

            this.showDeleteConfirmation('Deseja realmente excluir a exportação?', destroy)
        },
    },
    mixins: [ error, repository, stringCase ],
}
</script>